import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchCollection } from '../lib/api';
import GalleryLightbox from '../components/GalleryLightbox';

// Præcis kortlægning af billed-URL'er til deres rigtige reference-titler fra den oprindelige hjemmeside
function getImageLabel(url, galleryTitle, index) {
  if (!url) return '';

  // Erhverv & Offentligt
  if (url.includes('e05bc94e-b31e-428e-ad56-9233aa65e7f1') || url.includes('KA-huset-2012') || url.includes('16957640-f356-4db1-a50a-ff2becbd991d')) {
    return 'Kontorbygning i Randers (2012)';
  }
  if (url.includes('efa67f75-a46c-450f-8ba8-9b4178140535') || url.includes('SDC10327') || url.includes('e02866e9-2488-49b2-b9bc-75f8a130fd59')) {
    return 'Børnehus, Viborg';
  }
  if (
    url.includes('eca13339-4285-4c5b-b8a6-760b632c8917') ||
    url.includes('cbba17cd-b2d7-4c22-8324-abd515d4d0bb') ||
    url.includes('c9ddc715-53c0-4a26-a484-e54ac69e8ad4') ||
    url.includes('0c8c496a-f824-4910-a5f8-95405422f232') ||
    url.includes('e8620872-2e35-4838-a698-b3f514867817') ||
    url.includes('cd356f72-83d2-4654-bbf4-f67afd8d1049') ||
    url.includes('Sortebakkehallen')
  ) {
    return 'Sortebakkehallen, Nørager';
  }

  // Jordvarme & Varmeanlæg
  if (
    url.includes('8f3391fa-40e0-441a-9baa-b12024090a20') ||
    url.includes('Jordvarmeanlaeg-i-storre-bolig') ||
    url.includes('8fee4a11-f2f3-43fb-8da7-482af35e68fc') ||
    url.includes('8fee4a11') ||
    url.includes('82cdb11a-934f-4e50-84ad-55f78a320368')
  ) {
    return 'Større bolig med jordvarmeanlæg';
  }
  if (
    url.includes('28d1447b-613f-4c8b-aede-6ea7e02e3ea8') ||
    url.includes('3bfe2a8d-abf5-441f-b02b-34fd1e224d18') ||
    url.includes('Rishoejen-38') ||
    url.includes('7618d4c5-5b50-4953-ac80-3323ea36d25f') ||
    url.includes('4a2e79ab-dadc-40be-902c-0551d91ac489')
  ) {
    return 'Enfamiliehus med solvarme';
  }

  // Badeværelser
  if (
    url.includes('fb64ab4d-cbb8-4037-aa03-6756b45c8839') ||
    url.includes('7e03cc1d-8892-46c4-adfc-8ab696be4a1e') ||
    url.includes('d4d0172c-a7af-4dbb-aff7-ce76dd96e440') ||
    url.includes('Birkevej-24-Moeldrup') ||
    url.includes('926f5efe-0379-4ddd-88c1-856bdb5280b2') ||
    url.includes('eecc79bf-759e-473f-9d27-7218a7f71620')
  ) {
    return 'Renovering af badeværelse';
  }

  // Boligbyggeri & Renovering
  if (
    url.includes('c522deb5-46d8-46cd-a514-52a9bb5834bc') ||
    url.includes('a182a453-2a90-4226-b9be-d1fc77b3119b') ||
    url.includes('097ebb2b-b7d6-4027-9010-b7a5440443e1') ||
    url.includes('6fde8ffc-5d62-4ceb-bbac-61f4330f81c1')
  ) {
    return '72 boliger, Mårslet';
  }
  if (
    url.includes('6fde8cdc-b59c-4714-a04d-b2bd79381d5f') ||
    url.includes('735b6032-0985-4973-9458-e957c5671dd1') ||
    url.includes('6b5ac966-a020-4994-beba-7afd7cab6ad4')
  ) {
    return 'Boligbyggeri, Odder';
  }
  if (url.includes('1e22f272-50d6-48de-b88c-2784d1f2cd39') || url.includes('d49d3973-05ff-40c6-883b-459bb97c45a8')) {
    return 'Stuehus, Grauballe';
  }
  if (url.includes('41b9466c-9e3a-4aba-b888-9adac21badd0') || url.includes('436b51aa-a2ae-4d94-9048-485644ebd4b6')) {
    return '16 boliger, Sabro';
  }
  if (url.includes('31cb5788-4f5d-4290-b278-ebaa1120cc19') || url.includes('6a6992bd-49e9-4ca5-9156-e5e21cc5ed6d')) {
    return 'Enfamiliehus med gasinstallation og blikkenslagerarbejde';
  }
  if (url.includes('10e51c09-3838-40a4-b935-46aef7e90d90') || url.includes('cdd4ab5e-6315-4160-83a8-b4be0437294a')) {
    return 'SFO, Sjørslev';
  }
  if (
    url.includes('fdb45a3d-1eda-41f2-a591-7630206e2d07') ||
    url.includes('4d22fff0-24e1-4f1d-9940-72e901cd291f') ||
    url.includes('8da789a4-82b2-4ad4-bf6f-b0138ba05c49') ||
    url.includes('dbf78bd6-94d1-4369-86c7-8cf7bfa5f5cc') ||
    url.includes('7075834a-d0be-427f-a973-953b165b117d') ||
    url.includes('Vestermoelle')
  ) {
    return 'Kursuscenter Vestermølle, Skanderborg';
  }
  if (url.includes('8212245d-f28f-44e1-b104-2a5940e65bdc')) {
    return 'Vingård, Malling';
  }
  if (url.includes('8a2dfe87-eb6f-4f6f-a9f8-6a000ae63b9a')) {
    return 'Kontordomicil, Lystrup';
  }
  if (url.includes('a6d6254e-e104-4d9d-b46d-8857f4f9f9dc')) {
    return 'Saralystkirken, Højbjerg';
  }
  if (url.includes('d45ec78b-2f32-47c5-9e9e-b0655a669cea')) {
    return '57 boliger, Slet';
  }
  if (url.includes('e461bc8d-62c4-4225-b628-d0633a511867')) {
    return 'Bofællesskabet, Skive';
  }
  if (url.includes('deec1536-43f9-47d3-8ebb-0cb21303bec9')) {
    return 'Stregtegning af Møllegade 4';
  }

  return '';
}

export default function References() {
  const [galleries, setGalleries] = useState([]);
  const [sortedProjects, setSortedProjects] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    async function loadGalleries() {
      const data = await fetchCollection('galleri');
      setGalleries(data || []);
    }
    loadGalleries();
  }, []);

  useEffect(() => {
    if (galleries.length === 0) return;

    // Definer den præcise rækkefølge som ønsket af kunden
    const projectOrder = [
      "Kontorbygning i Randers (2012)",
      "Større bolig med jordvarmeanlæg",
      "Børnehus, Viborg",
      "Enfamiliehus med gasinstallation og blikkenslagerarbejde",
      "Stregtegning af Møllegade 4",
      "Boligbyggeri, Odder",
      "72 boliger, Mårslet",
      "Saralystkirken, Højbjerg",
      "Enfamiliehus med solvarme",
      "Sortebakkehallen, Nørager",
      "Stuehus, Grauballe",
      "Renovering af badeværelse",
      "57 boliger, Slet",
      "Bofællesskabet, Skive",
      "Vingård, Malling",
      "16 boliger, Sabro",
      "SFO, Sjørslev",
      "Kursuscenter Vestermølle, Skanderborg",
      "Kontordomicil, Lystrup"
    ];

    const projectMap = {};
    projectOrder.forEach(name => {
      projectMap[name] = [];
    });

    // Tilføj manuelt stregtegningen af Møllegade 4, da den er i listen over ønskede referencer
    projectMap["Stregtegning af Møllegade 4"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/6fde8ffc-5d62-4ceb-bbac-61f4330f81c1.jpg"
    );

    // Sørg for de specifikke billeder til Kontorbygning i Randers (2012) og Større bolig med jordvarmeanlæg
    projectMap["Kontorbygning i Randers (2012)"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/e05bc94e-b31e-428e-ad56-9233aa65e7f1.jpg"
    );
    projectMap["Større bolig med jordvarmeanlæg"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/8f3391fa-40e0-441a-9baa-b12024090a20.jpg"
    );

    // Sørg for de specifikke billeder til Børnehus, Viborg
    projectMap["Børnehus, Viborg"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/efa67f75-a46c-450f-8ba8-9b4178140535.jpg"
    );

    // Sørg for de specifikke billeder til Enfamiliehus med gasinstallation og blikkenslagerarbejde
    projectMap["Enfamiliehus med gasinstallation og blikkenslagerarbejde"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/c522deb5-46d8-46cd-a514-52a9bb5834bc.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/6fde8cdc-b59c-4714-a04d-b2bd79381d5f.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/1e22f272-50d6-48de-b88c-2784d1f2cd39.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/41b9466c-9e3a-4aba-b888-9adac21badd0.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/31cb5788-4f5d-4290-b278-ebaa1120cc19.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/a182a453-2a90-4226-b9be-d1fc77b3119b.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/735b6032-0985-4973-9458-e957c5671dd1.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/7618d4c5-5b50-4953-ac80-3323ea36d25f.jpg"
    );

    // Sørg for de specifikke billeder til Boligbyggeri, Odder
    projectMap["Boligbyggeri, Odder"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/8fee4a11-f2f3-43fb-8da7-482af35e68fc.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/926f5efe-0379-4ddd-88c1-856bdb5280b2.jpg"
    );

    // Sørg for de specifikke billeder til 72 boliger, Mårslet
    projectMap["72 boliger, Mårslet"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/10e51c09-3838-40a4-b935-46aef7e90d90.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/fdb45a3d-1eda-41f2-a591-7630206e2d07.jpg"
    );

    // Sørg for de specifikke billeder til Saralystkirken, Højbjerg
    projectMap["Saralystkirken, Højbjerg"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/80ded368-87ae-4722-b9c6-c2031283ebb9.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/27cf3838-1eb7-40bf-b9e5-862afb24683e.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/812cae1f-7c47-4f61-ba97-9f6672f96301.jpg"
    );

    // Sørg for de specifikke billeder til Enfamiliehus med solvarme
    projectMap["Enfamiliehus med solvarme"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/28d1447b-613f-4c8b-aede-6ea7e02e3ea8.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/3bfe2a8d-abf5-441f-b02b-34fd1e224d18.jpg"
    );

    // Sørg for de specifikke billeder til Sortebakkehallen, Nørager
    projectMap["Sortebakkehallen, Nørager"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/eca13339-4285-4c5b-b8a6-760b632c8917.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/cbba17cd-b2d7-4c22-8324-abd515d4d0bb.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/c9ddc715-53c0-4a26-a484-e54ac69e8ad4.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/0c8c496a-f824-4910-a5f8-95405422f232.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/e8620872-2e35-4838-a698-b3f514867817.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/cd356f72-83d2-4654-bbf4-f67afd8d1049.jpg"
    );

    // Sørg for de specifikke billeder til Stuehus, Grauballe
    projectMap["Stuehus, Grauballe"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/8212245d-f28f-44e1-b104-2a5940e65bdc.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/8a2dfe87-eb6f-4f6f-a9f8-6a000ae63b9a.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/a6d6254e-e104-4d9d-b46d-8857f4f9f9dc.jpg"
    );

    // Sørg for de specifikke billeder til Renovering af badeværelse
    projectMap["Renovering af badeværelse"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/fb64ab4d-cbb8-4037-aa03-6756b45c8839.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/7e03cc1d-8892-46c4-adfc-8ab696be4a1e.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/d4d0172c-a7af-4dbb-aff7-ce76dd96e440.jpg"
    );

    // Sørg for de specifikke billeder til 57 boliger, Slet
    projectMap["57 boliger, Slet"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/436b51aa-a2ae-4d94-9048-485644ebd4b6.jpg"
    );

    // Sørg for de specifikke billeder til Bofællesskabet, Skive
    projectMap["Bofællesskabet, Skive"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/6a6992bd-49e9-4ca5-9156-e5e21cc5ed6d.jpg"
    );

    // Sørg for de specifikke billeder til Vingård, Malling
    projectMap["Vingård, Malling"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/097ebb2b-b7d6-4027-9010-b7a5440443e1.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/6b5ac966-a020-4994-beba-7afd7cab6ad4.jpg"
    );

    // Sørg for de specifikke billeder til 16 boliger, Sabro
    projectMap["16 boliger, Sabro"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/d45ec78b-2f32-47c5-9e9e-b0655a669cea.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/e461bc8d-62c4-4225-b628-d0633a511867.jpg"
    );

    // Sørg for de specifikke billeder til SFO, Sjørslev
    projectMap["SFO, Sjørslev"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/cdd4ab5e-6315-4160-83a8-b4be0437294a.jpg"
    );

    // Sørg for de specifikke billeder til Kursuscenter Vestermølle, Skanderborg
    projectMap["Kursuscenter Vestermølle, Skanderborg"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/7075834a-d0be-427f-a973-953b165b117d.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/dbf78bd6-94d1-4369-86c7-8cf7bfa5f5cc.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/4d22fff0-24e1-4f1d-9940-72e901cd291f.jpg"
    );

    // Sørg for de specifikke billeder til Kontordomicil, Lystrup
    projectMap["Kontordomicil, Lystrup"].push(
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/16957640-f356-4db1-a50a-ff2becbd991d.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/e02866e9-2488-49b2-b9bc-75f8a130fd59.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/4a2e79ab-dadc-40be-902c-0551d91ac489.jpg",
      "https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/d49d3973-05ff-40c6-883b-459bb97c45a8.jpg"
    );

    // Grupper alle billeder fra CMS-gallerierne efter projektnavn
    galleries.forEach(gallery => {
      if (gallery.images) {
        gallery.images.forEach((img, index) => {
          const label = getImageLabel(img, gallery.title, index);
          if (label) {
            // Hvis det er et af de projekter, der kun skal have de specifikke billeder, skal vi ikke tilføje andre billeder
            if (
              label === "Kontorbygning i Randers (2012)" || 
              label === "Større bolig med jordvarmeanlæg" ||
              label === "Børnehus, Viborg" ||
              label === "Enfamiliehus med gasinstallation og blikkenslagerarbejde" ||
              label === "Stregtegning af Møllegade 4" ||
              label === "Boligbyggeri, Odder" ||
              label === "72 boliger, Mårslet" ||
              label === "Saralystkirken, Højbjerg" ||
              label === "Enfamiliehus med solvarme" ||
              label === "Sortebakkehallen, Nørager" ||
              label === "Stuehus, Grauballe" ||
              label === "Renovering af badeværelse" ||
              label === "57 boliger, Slet" ||
              label === "Bofællesskabet, Skive" ||
              label === "Vingård, Malling" ||
              label === "16 boliger, Sabro" ||
              label === "SFO, Sjørslev" ||
              label === "Kursuscenter Vestermølle, Skanderborg" ||
              label === "Kontordomicil, Lystrup"
            ) {
              return;
            }
            if (!projectMap[label]) {
              projectMap[label] = [];
            }
            if (!projectMap[label].includes(img)) {
              projectMap[label].push(img);
            }
          }
        });
      }
    });

    // Konverter til sorteret array baseret på den præcise rækkefølge
    const sorted = projectOrder
      .map(name => ({
        name,
        images: projectMap[name] || []
      }))
      .filter(project => project.images.length > 0);

    // Tilføj eventuelle øvrige projekter, der ikke var i listen (for en sikkerheds skyld)
    Object.keys(projectMap).forEach(name => {
      if (!projectOrder.includes(name) && projectMap[name].length > 0) {
        sorted.push({
          name,
          images: projectMap[name]
        });
      }
    });

    setSortedProjects(sorted);
  }, [galleries]);

  const openLightbox = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <Helmet>
        <title>Referencer – Møldrup VVS A/S</title>
        <meta name="description" content="Se billeder og beskrivelser af vores udførte VVS- og blikkenslagerarbejde for private, erhverv og offentlige kunder." />
        <html lang="da" />
      </Helmet>

      {/* Hero Banner */}
      <section className="relative bg-slate-950 text-white py-24 md:py-32 border-b border-slate-900">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/0cd8fe7f-0ba4-47e3-908a-4fc623bd309c.jpg"
            alt="Referencer"
            className="w-full h-full object-cover opacity-10"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-12">
          <span className="text-blue-500 text-xs font-extrabold tracking-[0.25em] uppercase block mb-3">
            Udført arbejde
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-wider uppercase">
            Referencer
          </h1>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-2xl leading-relaxed">
            Vi er stolte af det arbejde, vi leverer. Gennemse vores gallerier nedenfor for at se konkrete eksempler på vores løsninger.
          </p>
        </div>
      </section>

      {/* Galleries List Section */}
      <section className="py-24 bg-white text-slate-900">
        <div className="max-w-7xl mx-auto px-6">
          {sortedProjects.length === 0 ? (
            <div className="text-center py-12 text-gray-500 font-semibold uppercase tracking-wider text-sm">
              Indlæser referencer...
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {sortedProjects.map((project, pIdx) => (
                <div
                  key={pIdx}
                  onClick={() => openLightbox(project.images, 0)}
                  className="flex flex-col bg-slate-50 border border-gray-100 overflow-hidden cursor-pointer group transition-all duration-300 hover:border-blue-500/30 hover:shadow-md relative"
                >
                  {/* Image Container */}
                  <div className="relative aspect-video overflow-hidden bg-slate-950">
                    <img
                      src={project.images[0]}
                      alt={project.name}
                      className="w-full h-full object-cover opacity-90 transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </div>
                  
                  {/* Text Label Below Image */}
                  <div className="p-4 bg-white flex-1 flex items-center border-t border-gray-100 group-hover:bg-slate-50 transition-colors duration-300">
                    <p className="text-xs font-bold text-slate-800 uppercase tracking-wider leading-snug">
                      {project.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && (
        <GalleryLightbox
          images={lightboxImages}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
}
